<div class="program-progress-section">
  <div class="program-progress">
    <div class="program-progress-info-content">
      <div class="program-progress-title">
        <div class="body-s">{{ 'translations.completion' | transloco }}</div>
        <div class="body-s" *ngIf="goal()?.progressCounter?.counter === 'NUMBER'">
          {{ goal().completedCards }}<span class="small">/{{ goal().totalCards }}</span>
        </div>
        <div class="body-s" *ngIf="goal()?.progressCounter?.counter === 'PERCENTAGE'">
          {{ goalCompletedPercentage() }}<span class="small">%</span>
        </div>
      </div>
      <div class="program-goal-card-number-progress-container">
        <div class="program-goal-card-number-progress-box">
          <div class="program-goal-card-number-progress">
            <span class="program-goal-card-number-progress-bg" [style.background-color]="goal()?.color"></span>
            <span
              class="program-goal-card-number-progress-value"
              [style.background-color]="goal()?.color"
              [style.width]="goalCompletedPercentage() + '%'"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
